module.exports = __webpack_public_path__ + "img/settings-1.7a69970d.webp";